__webpack_require__.p = "https://www.wolframcloud.com/obj/resourcesystem/published/DemonstrationRepository/webresources/";